import { gql } from '@apollo/client'

export const GET_ALL_CONFIG_APP = gql`
  query GetAllConfigApp($searchQuery: String, $limit: Int, $offset: Int) {
    getAllConfigApp(searchQuery: $searchQuery, limit: $limit, offset: $offset) {
      rows {
        id
        name
        visible
      }
      count
    }
  }
`

export const GET_ONE_CONFIG_APP = gql`
  query GetOneConfigApp($id: Int!) {
    getOneConfigApp(id: $id) {
      id
      name
      json_config
      visible
    }
  }
`

export const CREATE_CONFIG_APP = gql`
  mutation CreateConfigApp($input: ConfigAppInput!) {
    createConfigApp(input: $input)
  }
`

export const UPDATE_CONFIG_APP = gql`
  mutation UpdateConfigApp($configAppId: Int!, $input: ConfigAppInput!) {
    updateConfigApp(configAppId: $configAppId, input: $input)
  }
`

export const DELETE_CONFIG_APP = gql`
  mutation DeleteConfigApp($id: Int!) {
    deleteConfigApp(id: $id)
  }
`

export const UPDATE_CONFIG_APP_ONLY_FILE = gql`
  mutation UpdateConfigAppOnlyFile(
    $input: ConfigAppInputFile!
    $configAppId: Int!
  ) {
    updateConfigAppOnlyFile(input: $input, configAppId: $configAppId)
  }
`

export const UPDATE_CONFIG_APP_ONLY_FILE_DELETE = gql`
  mutation UpdateConfigAppOnlyFileDelete($configAppId: Int!, $urlKey: String!) {
    updateConfigAppOnlyFileDelete(configAppId: $configAppId, urlKey: $urlKey)
  }
`
